<template>
  <div class="container mx-auto my-20">
    <h2
      class="text-center mx-auto max-w-6xl text-2xl sm:text-3xl lg:text-4xl mb-10"
      v-html="dataLocale.data.title"
    ></h2>
    <p class="text-lg md:text-xl text-center mx-auto max-w-2xl">
      {{ dataLocale.data.description }}
    </p>
  </div>
</template>
<script lang="ts" setup>
import DataLocale from "~~/config/interface/DataLocale";

const dataLocale = new DataLocale([
  {
    locale: "en",
    title:
      'Tailored Solutions for <span class="down-mark-line">Customization</span>',
    description:
      "A bespoke solution designed for organizations seeking additional QR codes, white-labeling, API integration, and other premium features.",
  },
  {
    locale: "fr",
    title:
      'Solutions sur mesure pour la <span class="down-mark-line">personnalisation</span>',
    description:
      "Une solution sur mesure conçue pour les organisations recherchant des codes QR supplémentaires, une marque blanche, une intégration API et d'autres fonctionnalités premium.",
  },
  {
    locale: "it",
    title:
      'Soluzioni su misura per la <span class="down-mark-line">personalizzazione</span>',
    description:
      "Una soluzione su misura progettata per le organizzazioni che cercano codici QR aggiuntivi, white-labeling, integrazione API e altre funzionalità premium.",
  },
  {
    locale: "de",
    title:
      'Maßgeschneiderte Lösungen für <span class="down-mark-line">Anpassung</span>',
    description:
      "Eine maßgeschneiderte Lösung für Organisationen, die zusätzliche QR-Codes, White-Labeling, API-Integration und andere Premium-Funktionen suchen.",
  },
  {
    locale: "es",
    title:
      'Soluciones a medida para la <span class="down-mark-line">personalización</span>',
    description:
      "Una solución a medida diseñada para organizaciones que buscan códigos QR adicionales, marca blanca, integración de API y otras funciones premium.",
  },
  {
    locale: "nl",
    title:
      'Oplossingen op maat voor <span class="down-mark-line">aanpassing</span>',
    description:
      "Een maatwerkoplossing ontworpen voor organisaties die op zoek zijn naar extra QR-codes, white-labeling, API-integratie en andere premiumfuncties.",
  },
  {
    locale: "pt",
    title:
      'Soluções sob medida para <span class="down-mark-line">personalização</span>',
    description:
      "Uma solução personalizada projetada para organizações que buscam códigos QR adicionais, white-labeling, integração de API e outros recursos premium.",
  },
  {
    locale: "ja",
    title:
      '<span class="down-mark-line">カスタマイズ</span>のためのテーラーメイドソリューション',
    description:
      "追加のQRコード、ホワイトラベリング、API統合、その他のプレミアム機能を求める組織向けに設計されたオーダーメイドソリューション。",
  },
  {
    locale: "zh",
    title: '<span class="down-mark-line">定制</span>的量身定制解决方案',
    description:
      "专为寻求额外二维码、白标、API 集成和其他高级功能的组织而设计的定制解决方案。",
  },
  {
    locale: "vi",
    title:
      'Giải pháp phù hợp cho <span class="down-mark-line">Tùy chỉnh</span>',
    description:
      "Một giải pháp được thiết kế riêng cho các tổ chức tìm kiếm mã QR bổ sung, nhãn trắng, tích hợp API và các tính năng cao cấp khác.",
  },
  {
    locale: "id",
    title:
      'Solusi yang Disesuaikan untuk <span class="down-mark-line">Kustomisasi</span>',
    description:
      "Solusi yang dipesan lebih dahulu yang dirancang untuk organisasi yang mencari kode QR tambahan, white-labeling, integrasi API, dan fitur premium lainnya.",
  },
  {
    locale: "tr",
    title:
      '<span class="down-mark-line">Özelleştirme</span> için Özel Çözümler',
    description:
      "Ek QR kodları, beyaz etiketleme, API entegrasyonu ve diğer premium özellikleri arayan kuruluşlar için tasarlanmış özel bir çözüm.",
  },
  {
    locale: "hi",
    title: '<span class="down-mark-line">अनुकूलन</span> के लिए अनुकूलित समाधान',
    description:
      "अतिरिक्त क्यूआर कोड, व्हाइट-लेबलिंग, एपीआई एकीकरण और अन्य प्रीमियम सुविधाओं की तलाश करने वाले संगठनों के लिए डिज़ाइन किया गया एक कस्टम समाधान।",
  },
  {
    locale: "th",
    title:
      'โซลูชันที่ปรับแต่งได้สำหรับ<span class="down-mark-line">การปรับแต่ง</span>',
    description:
      "โซลูชันที่ออกแบบเองสำหรับองค์กรที่ต้องการรหัส QR เพิ่มเติม การติดฉลากสีขาว การรวม API และคุณสมบัติพิเศษอื่นๆ",
  },
]);
</script>
